export default __webpack_public_path__ + "static/saoldisplay-regularitalic-webfont-e21adca84efb2e3a22c97246fa4983a9.woff";